/**
 * Query keys for survey response React Query hooks
 * Following established pattern from other features
 */

export const surveyResponseQueryKeys = {
  // Base key for all survey response queries
  all: ['surveyResponse'] as const,

  // Public survey instance queries
  publicInstances: () => [...surveyResponseQueryKeys.all, 'publicInstances'] as const,
  publicInstance: (instanceId: string) =>
    [...surveyResponseQueryKeys.publicInstances(), instanceId] as const,
  instanceStatus: (instanceId: string) =>
    [...surveyResponseQueryKeys.publicInstance(instanceId), 'status'] as const,

  // Session queries
  sessions: () => [...surveyResponseQueryKeys.all, 'sessions'] as const,
  session: (instanceId: string, sessionId: string) =>
    [...surveyResponseQueryKeys.sessions(), instanceId, sessionId] as const,
  sessionProgress: (instanceId: string, sessionId: string) =>
    [...surveyResponseQueryKeys.session(instanceId, sessionId), 'progress'] as const,

  // Response queries
  responses: () => [...surveyResponseQueryKeys.all, 'responses'] as const,
  response: (instanceId: string, sessionId: string) =>
    [...surveyResponseQueryKeys.responses(), instanceId, sessionId] as const,
  responseValidation: (instanceId: string, sessionId: string) =>
    [...surveyResponseQueryKeys.response(instanceId, sessionId), 'validation'] as const,
} as const;
